import { useDrawer } from '@cast/design-system';

import {
  EdgeLocationDetailsDrawer,
  EdgeLocationDetailsDrawerProps,
} from './EdgeLocationDetailsDrawer';

export const useEdgeLocationDetailsDrawer = () => {
  const { open } = useDrawer();

  return {
    openEdgeLocationDetailsDrawer: (props: EdgeLocationDetailsDrawerProps) => {
      open({ component: EdgeLocationDetailsDrawer, props });
    },
  };
};
